import api from "$services/api";

const canaryApi = {
    getConfig: (signal) => api.get("/api/admin/canary/config", null, { signal }),
    updateClients: (clients) => api.put("/api/admin/canary/config/clients", clients),
    updateRandomCount: (count) => api.put("/api/admin/canary/config/random-count", { count }),
    getLatestSnapshots: (signal) => api.get("/api/admin/canary/snapshots/latest", null, { signal }),
};

export default canaryApi;
